import { render, staticRenderFns } from "./CurrencyAdmin.vue?vue&type=template&id=6db78a3d&"
import script from "./CurrencyAdmin.vue?vue&type=script&lang=js&"
export * from "./CurrencyAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports